import { FC } from 'react';
import { ShiftModal } from 'modals/ShiftModal';
import { InviteTeamMembersModal } from 'modals/InviteTeamMembersModal';
import { withMemo } from 'utils/withMemo';
import { AuthGuard } from 'guards/AuthGuard';
import { CustomFieldEditModal } from 'modals/CustomFieldEditModal';
import { CustomFieldCreateModal } from 'modals/CustomFieldCreateModal';
import { TimeOffModal } from 'modals/TimeOffModal';
import { JaneDetailsModal } from 'modals/JaneDetailsModal';

const GlobalModalsComponent: FC = (): JSX.Element => {
  return (
    <AuthGuard>
      <CustomFieldEditModal />
      <CustomFieldCreateModal />
      <TimeOffModal />
      <ShiftModal />
      <InviteTeamMembersModal />
      <JaneDetailsModal />
    </AuthGuard>
  );
};

export const GlobalModals = withMemo(GlobalModalsComponent);
